'use client';

import { useState, useEffect } from 'react';
import ContactForm from './ContactForm';
import ExecutiveContacts from './ExecutiveContacts';
import RegionalOffices from './RegionalOffices';
import ResponseCommitments from './ResponseCommitments';

const ContactInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="space-y-12">
        <div className="animate-pulse space-y-8">
          <div className="h-64 bg-muted rounded-sm"></div>
          <div className="h-96 bg-muted rounded-sm"></div>
          <div className="h-264 bg-muted rounded-sm"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-12">
      <ContactForm selectedInquiryType="general" />
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <ExecutiveContacts />
        <ResponseCommitments />
      </div>
      
      <RegionalOffices />
    </div>
  );
};

export default ContactInteractive;